export enum InputEnum {
  TEXT = "text",
  TEXT_AREA = "text-area",
  SELECT = "select",
  SWITCH = "switch"
}
